// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file session_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file session_type.proto.
 */
export const file_session_type: GenFile = /*@__PURE__*/
  fileDesc("ChJzZXNzaW9uX3R5cGUucHJvdG8SBmRvbWFpbirqAQoLU2Vzc2lvblR5cGUSGAoUU0VTU0lPTl9UWVBFX1VOS05PV04QABInCiNTRVNTSU9OX1RZUEVfU0VMRl9VTkxPQ0tJTkdfUFJJTUFSWRABEikKJVNFU1NJT05fVFlQRV9TRUxGX1VOTE9DS0lOR19TRUNPTkRBUlkQAhIaChZTRVNTSU9OX1RZUEVfQkFDS1VQX09TEAMSHAoYU0VTU0lPTl9UWVBFX0JBQ0tVUF9DT0RFEAQSGgoWU0VTU0lPTl9UWVBFX0NPTk5FQ1RFRBAFEhcKE1NFU1NJT05fVFlQRV9FU0NST1cQBkIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM");

/**
 * @generated from enum domain.SessionType
 */
export enum SessionType {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: SESSION_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Mobile apps that manage the backup OS authenticator, Android and iOS apps.
   *
   * @generated from enum value: SESSION_TYPE_SELF_UNLOCKING_PRIMARY = 1;
   */
  SELF_UNLOCKING_PRIMARY = 1,

  /**
   * Secondary mobile clients that do not manage the backup OS authenticator, Android tablets and iPads.
   *
   * @generated from enum value: SESSION_TYPE_SELF_UNLOCKING_SECONDARY = 2;
   */
  SELF_UNLOCKING_SECONDARY = 2,

  /**
   * Cloud backups on Android and iOS
   *
   * @generated from enum value: SESSION_TYPE_BACKUP_OS = 3;
   */
  BACKUP_OS = 3,

  /**
   * Backup code used for recovery
   *
   * @generated from enum value: SESSION_TYPE_BACKUP_CODE = 4;
   */
  BACKUP_CODE = 4,

  /**
   * Connected sessions are web and ext
   *
   * @generated from enum value: SESSION_TYPE_CONNECTED = 5;
   */
  CONNECTED = 5,

  /**
   * Escrow authenticator used for pairing, to be replaced by session unlock authenticator
   *
   * @generated from enum value: SESSION_TYPE_ESCROW = 6;
   */
  ESCROW = 6,
}

/**
 * Describes the enum domain.SessionType.
 */
export const SessionTypeSchema: GenEnum<SessionType> = /*@__PURE__*/
  enumDesc(file_session_type, 0);

